<template>
  <prism-editor class="prism-editor" v-model="valueComp" :highlight="highlighter" v-bind="$attrs" />
</template>

<script>
import { PrismEditor } from 'vue-prism-editor'
import 'vue-prism-editor/dist/prismeditor.min.css'

import { highlight, languages } from 'prismjs/components/prism-core'
import 'prismjs/components/prism-clike'
import 'prismjs/components/prism-javascript'
import 'prismjs/components/prism-css'
import 'prismjs/components/prism-json'
import 'prismjs/themes/prism-coy.css'

export default {
  props: {
    value: String,
    language: {
      type: String,
      required: true,
    },
  },
  computed: {
    valueComp: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      },
    },
  },
  methods: {
    highlighter(code) {
      return highlight(code, languages[this.language])
    },
  },
  components: {
    PrismEditor,
  },
}
</script>

<style>
.prism-editor {
  word-break: break-all;
  font-family: Fira code, Fira Mono, Consolas, Menlo, Courier, monospace;
  font-size: 14px;
  line-height: 1.5;
  padding: 5px;
}

.prism-editor__textarea:focus {
  outline: none;
}
</style>
